module.exports = __webpack_public_path__ + "img/37.0c57344f.jpg";